export const transformTickets = tickets => {
    // first we group tickets by transactionId to avoid duplicates,
    // because we need to track only one ticket per transaction
    const grouped = tickets.reduce((result, value, index) => {
        if (!result[value.transactionId]) {
            result[value.transactionId] = []
        }
        result[value.transactionId].push(value)
        return result
    }, {})
    // if we find any open ticket for some transaction, we push it to result array immediately
    // if no open tickets were found, then we need to find the most recent closed ticket,
    // so we compare closed tickets by ticketCloseDate
    let filteredTickets = []
    for (let key in grouped) {
        if (grouped[key].length) {
            const openedTicket = grouped[key].find(ticket => ticket.ticketStatus !== 'Ticket Closed')
            if (openedTicket) {
                filteredTickets.push(openedTicket)
            } else {
                const closedTicket = grouped[key].reduce((a, b) => (new Date(a.ticketCloseDate) > new Date(b.ticketCloseDate) ? a : b))
                filteredTickets.push(closedTicket)
            }
        }
    }
    return filteredTickets
}
